<template>
  <section class="container-whatsapp">
    <a class="button btn-whatsapp" :href="whatsappRef">
      <img src="./../../assets/icon-whatsapp.svg" alt="icon Whatsapp" />
      Comunícate con un asesor comercial
    </a>
  </section>
</template>

<script>
export default {
  name: "WhatsappButton",
  data() {
    return {
      whatsappRef: "http://api.whatsapp.com/send?phone=541131632066",
    };
  },
};
</script>

<style>
.container-whatsapp {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
}
.btn-whatsapp {
  margin: 0 auto;
  top: -30px;
  width: fit-content;
  display: grid;
  grid-template-columns: 40px auto;
  padding: 7px;
  justify-items: center;
  align-content: center;
  background-color: #05ac21;
  color: #fff;
  font-size: 18px;
}
.btn-whatsapp img {
  width: fit-content;
  height: 30px;
  margin: 0 auto;
  filter: invert(1);
}
</style>
